export default {
	queryLimit: 200,
	initialQueryDistance: 3600,
	locationInput: '#locationInput',
	main: '#locate-a-club',
	map: '#map',
	mapTab: '#mapTab',
	results: '#results',
	resultsList: '.results-list li',
	resultsListContainer: '.results-list',
	resultsNone: '[class*="results-none"]',
	resultsNoneNearby: '.results-none-nearby',
	resultsNoneFilter: '.results-none-filters',
	resultsNoneDefault: '.results-none-default',
	resultsCountNum: '.results-count span.font-weight-bold',
	resultsCountStr: '.results-count span.search-string',
	toggleFilterControls: '#toggleFilterControls',
	filterInput: '#filterControls input',
	filterInputChecked: '#filterControls input:checked'
};
